import postawaImage from "../../assets/POSTAWA.png";
import mowaImage from "../../assets/MOWA.png";
import gestImage from "../../assets/GEST.png";
import chodImage from "../../assets/CHOD.png";
import redblue from "../../assets/red-blue.png";
import redgreen from "../../assets/red-green.png";
import redred from "../../assets/red-red.png";
import redyellow from "../../assets/red-yellow.png";
import t from "../../translations";

export default [
  {
    title: t("red_section_one_title"),
    subSections: [
      {
        title: t("red_subsection_one_title"),
        description: [
          t("red_subsection_one_description_one"),
          t("red_subsection_one_description_two"),
          t("red_subsection_one_description_three"),
          t("red_subsection_one_description_four"),
          t("red_subsection_one_description_five"),
          t("red_subsection_one_description_six"),
        ],
        positionText: "right",
      },
      { image: (props) => tImage("red_chart", props) },
      {
        title: t("red_subsection_two_title"),
        description: [
          t("red_subsection_two_description_one"),
          t("red_subsection_two_description_two"),
        ],
        positionText: "right",
      },
      {
        title: t("red_subsection_three_title"),
        description: [
          t("red_subsection_three_description_one"),
          t("red_subsection_three_description_two"),
        ],
        positionText: "right",
      },
    ],
  },
  {
    title: t("red_section_two_title"),
    subSections: [
      {
        title: t("red_subsection_two_one_title"),
        description: [
          t("red_subsection_two_one_description_one"),
          t("red_subsection_two_one_description_two"),
        ],
        image: postawaImage,
        positionText: "right",
      },
      {
        title: t("red_subsection_two_two_title"),
        description: [t("red_subsection_two_two_description_one")],
        image: chodImage,
      },
      {
        title: t("red_subsection_two_three_title"),
        description: [
          t("red_subsection_two_three_description_one"),
          t("red_subsection_two_three_description_two"),
          t("red_subsection_two_three_description_three"),
          t("red_subsection_two_three_description_four"),
          t("red_subsection_two_three_description_five"),
        ],
        image: gestImage,
        positionText: "right",
      },
      {
        title: t("red_subsection_two_four_title"),
        description: [
          t("red_subsection_two_four_description_one"),
          t("red_subsection_two_four_description_two"),
          t("red_subsection_two_four_description_three"),
          t("red_subsection_two_four_description_four"),
          t("red_subsection_two_four_description_five"),
          t("red_subsection_two_four_description_six"),
        ],
        image: mowaImage,
      },
    ],
  },
  {
    title: t("red_section_three_title"),
    subSections: [
      {
        title: t("red_subsection_three_one_title"),
        description: [
          t("red_subsection_three_one_description_one"),
          t("red_subsection_three_one_description_two"),
          t("red_subsection_three_one_description_three"),
        ],
        positionText: "right",
      },
      { image: (props) => tImage("redInStress_chart", props) },
      {
        title: t("red_subsection_three_two_title"),
        description: [
          t("red_subsection_three_two_description_one"),
          t("red_subsection_three_two_description_two"),
          t("red_subsection_three_two_description_three"),
        ],
        positionText: "right",
      },
      {
        title: t("red_subsection_three_three_title"),
        description: [
          t("red_subsection_three_three_description_one"),
          t("red_subsection_three_three_description_two"),
        ],
        positionText: "right",
      },
    ],
  },
  {
    title: t("red_section_four_title"),
    subSections: [
      {
        description1: t("red_subsection_four_one_description1_one"),
        description2: t("red_subsection_four_one_description2_two"),
      },
      { image: (props) => tImage("team_image", props) },
    ],
  },
  {
    title: t("red_section_five_title"),
    subSections: [
      {
        title: t("red_subsection_five_one_title"),
        description: t("red_subsection_five_one_description_one"),
        isOneAboveAnother: true,
      },
      {
        title: t("red_subsection_five_two_title"),
        description: [
          t("red_subsection_five_two_description_one"),
          t("red_subsection_five_two_description_two"),
          t("red_subsection_five_two_description_three"),
          t("red_subsection_five_two_description_four"),
          t("red_subsection_five_two_description_five"),
        ],
        positionText: "right",
      },
      { image: (props) => tImage("communication_image", props) },
      {
        title: t("red_subsection_five_three_title"),
        description: [
          t("red_subsection_five_three_description_one"),
          t("red_subsection_five_three_description_two"),
          t("red_subsection_five_three_description_three"),
          t("red_subsection_five_three_description_four"),
        ],
      },
    ],
  },
  {
    title: t("red_section_six_title"),
    subSections: [
      {
        title: t("red_subsection_six_one_title"),
        description: true,
      },
      {
        title: t("red_subsection_six_two_title"),
        description: [
          t("red_subsection_six_two_description_one"),
          t("red_subsection_six_two_description_two"),
          t("red_subsection_six_two_description_three"),
          t("red_subsection_six_two_description_four"),
        ],
        image: redred,
        positionText: "right",
      },
      {
        title: t("red_subsection_six_three_title"),
        description: [
          t("red_subsection_six_three_description_one"),
          t("red_subsection_six_three_description_two"),
          t("red_subsection_six_three_description_three"),
          t("red_subsection_six_three_description_four"),
          t("red_subsection_six_three_description_five"),
          t("red_subsection_six_three_description_six"),
        ],
        image: redyellow,
        positionText: "right",
      },
      {
        title: t("red_subsection_six_four_title"),
        description: [
          t("red_subsection_six_four_description_one"),
          t("red_subsection_six_four_description_two"),
          t("red_subsection_six_four_description_three"),
          t("red_subsection_six_four_description_four"),
          t("red_subsection_six_four_description_five"),
          t("red_subsection_six_four_description_six"),
          t("red_subsection_six_four_description_seven"),
          t("red_subsection_six_four_description_eight"),
          t("red_subsection_six_four_description_nine"),
        ],
        image: redblue,
        positionText: "right",
      },
      {
        title: t("red_subsection_six_five_title"),
        description: [
          t("red_subsection_six_five_description_one"),
          t("red_subsection_six_five_description_two"),
          t("red_subsection_six_five_description_three"),
          t("red_subsection_six_five_description_four"),
          t("red_subsection_six_five_description_five"),
          t("red_subsection_six_five_description_six"),
          t("red_subsection_six_five_description_seven"),
          t("red_subsection_six_five_description_eight"),
        ],
        image: redgreen,
        positionText: "right",
      },
    ],
  },
];
